import haveError from './HaveError';

export default function readError(errors: Object, field: string) {
  return haveError(errors, field) ? errors[field] : null;
}
